export default "__VITE_ASSET__BuaVuo5X__"